export const DarkTheme = {
    bodybgColor: '#000000',
    textColor: '#ffffff',
    divbgColor: 'darkgreen',
};
